import { render, staticRenderFns } from "./LoadingDataError.vue?vue&type=template&id=27769ed1"
import script from "./LoadingDataError.vue?vue&type=script&lang=js"
export * from "./LoadingDataError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports